import { PAYMENT_TYPES } from 'portal-modules/payments/constants/types'
import PropTypes from 'prop-types'
import React from 'react'
import {
  Amex,
  Discover,
  Mastercard,
  Sepa,
  PAD as Pad,
  VisaCard,
} from '@entrata/portals-common/lib/icons/card'
import cardIcons from 'portal-modules/payments/constants/card-icons'

const CardIcon = ({ id, width, height, size }) => {
  switch (id) {
    case PAYMENT_TYPES.ECHECK.value:
    case PAYMENT_TYPES.PAD.value:
      return <Pad width={width} height={height} key={id} size={size} />
    case PAYMENT_TYPES.VISA.value:
      return <VisaCard width={width} height={height} key={id} size={size} />
    case PAYMENT_TYPES.MASTERCARD.value:
      return <Mastercard width={width} height={height} key={id} size={size} />
    case PAYMENT_TYPES.DISCOVER.value:
      return <Discover width={width} height={height} key={id} size={size} />
    case PAYMENT_TYPES.AMEX.value:
      return <Amex width={width} height={height} key={id} size={size} />
    case PAYMENT_TYPES.SEPA.value:
      return <Sepa width={width} height={height} key={id} size={size} />
    case PAYMENT_TYPES.MONEYGRAM.value:
      var Icon = cardIcons[id].icon
      return <Icon width={width} height={height} key={id} size={size} />
    case PAYMENT_TYPES.INSTANT_BANK_TRANSFER.value:
      var IBT = cardIcons[id]
      return <IBT width={width} height={height} key={id} size={size} />
    case PAYMENT_TYPES.UNION_PAY.value:
      var UnionPay = cardIcons[id]
      return <UnionPay width={width} height={height} key={id} size={size} />
    case PAYMENT_TYPES.APPLE_PAY.value:
      let ApplePay = cardIcons[id]
      return <ApplePay width={width} height={height} key={id} size={size} />
    case PAYMENT_TYPES.CARD.value:
      var PaymentCard = cardIcons[id]
      return <PaymentCard width={width} height={height} key={id} size={size} />
    case PAYMENT_TYPES.BACS.value:
      let Bacs = cardIcons[id]
      return <Bacs width={width} height={height} key={id} size={size} />
    default:
      return null
  }
}

CardIcon.propTypes = {
  id: PropTypes.number,
  width: PropTypes.string,
  height: PropTypes.string,
  size: PropTypes.string,
}

CardIcon.defaultProps = {
  size: '',
}

export default CardIcon
